import Dashboard from "../dashboard/modules/dashboard/views/dashboardLayout.vue";
import ReinstatementList from "./components/ReinstatementList.vue";
import ReinstatementInvoice from "./components/ReinstatementInvoice.vue";
import Auth from "../dashboard/modules/auth/middleware/Auth";
import Reinstatement from "./views/Reinstatement.vue";

export default [
  {
    path: "/reinstatement",
    component: Dashboard,
    children: [
      {
        path: "",
        component: Reinstatement,
        meta: {
          title: "KISEB::Reinstatement",
          page: "Reinstatement",
        },
        children: [
          {
            path: "list",
            name: "ReinstatementList",
            component: ReinstatementList,
            meta: { middleware: [Auth] },
          },
          {
            path: "invoice/:code",
            name: "ReinstatementInvoice",
            component: ReinstatementInvoice,
            meta: { middleware: [Auth] },
          },
        ],
      },
    ],
  },
];
